import { useState } from 'react';
import { View, ScrollView, TouchableOpacity, Modal } from 'react-native';
import { Text } from '@/components';
import { Image } from 'expo-image';
import styles from './collectible.styles';
import { useRouter } from 'expo-router';
import { useCollectibles } from '@/lib/queries/account';
import { useAuth } from '@/context/AuthContext';
import { useTranslation } from 'react-i18next';
import { logEvent } from '@/lib/analytics';


export default function CollectibleScreen() {
  const { session } = useAuth();
  const { collectibles, collectibleSvgs } = useCollectibles(session?.accessToken);
  const { t } = useTranslation();
  console.log("Collectibles:", collectibles);
  const router = useRouter();
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => router.push('/profile')} style={styles.backButton}>
          <Text style={styles.backText}>{t('collectibles.back')}</Text>
        </TouchableOpacity>
        <Text style={styles.title}>{t('collectibles.title')}</Text>
        <View style={styles.spacer} />
      </View>

      {/* Collectibles List */}
      <ScrollView contentContainerStyle={styles.content}>
        {collectibles.map((collectible, i) => (
          <TouchableOpacity
            key={`${collectible.name}-${i}`}
            style={styles.item}
            activeOpacity={0.85}
            onPress={() => {
              setSelectedIndex(i);
              logEvent('view_item', { item_id: collectible.name, item_name: collectible.name });
              router.push(`/collectible-detail?index=${i}`);
            }}
          >
            {collectible.preview_url ? (
              <Image
                source={{ uri: collectible.preview_url }}
                style={styles.thumb}
                contentFit="cover"
                cachePolicy="memory-disk"
              />
            ) : (
              <View style={styles.thumb} />
            )}
            <View style={styles.itemText}>
              <Text style={styles.itemTitle}>{collectible.name}</Text>
              <Text style={styles.itemDesc}>{collectible.description}</Text>
            </View>
          </TouchableOpacity>
        ))}
      </ScrollView>
      {/* Detail screen opened via router when tapping an item */}
    </View>
  );
}

